'use strict';

var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.js");
var Url$PvpcontrollerWeb = require("./Url.js");
var Request$PvpcontrollerWeb = require("./Request.js");
var SettingsModel$PvpcontrollerWeb = require("../models/SettingsModel.js");
var UpdateResponse$PvpcontrollerWeb = require("./UpdateResponse.js");
var EditModeService$PvpcontrollerWeb = require("./EditModeService.js");

function settingsResponse(json) {
  return {
          status: Json_decode.field("status", Json_decode.$$int, json),
          settings: Json_decode.field("settings", SettingsModel$PvpcontrollerWeb.Decode.settings, json)
        };
}

function settingsChangelogResponse(json) {
  return {
          status: Json_decode.field("status", Json_decode.$$int, json),
          changes: Json_decode.field("changes", (function (param) {
                  return Json_decode.array(EditModeService$PvpcontrollerWeb.Decode.change, param);
                }), json),
          totalSize: Json_decode.field("totalSize", Json_decode.$$int, json)
        };
}

function getSettings(cb) {
  return Request$PvpcontrollerWeb.getWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings", (function (response) {
                return {
                        TAG: /* Ok */0,
                        _0: settingsResponse(response).settings
                      };
              }), cb);
}

function updateDamageDisableSeconds(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var damageDisableSeconds = String(param$1.damageDisableSeconds);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/damageDisableSeconds", "damageDisableSeconds=" + damageDisableSeconds + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateBanPrefixedArmor(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var banPrefixedArmor = param$1.banPrefixedArmor ? "true" : "false";
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/banPrefixedArmor", "banPrefixedArmor=" + banPrefixedArmor + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateBanTeleportItems(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var banTeleportItems = param$1.banTeleportItems ? "true" : "false";
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/banTeleportItems", "banTeleportItems=" + banTeleportItems + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updatePotionHealAmount(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var potionHealAmount = String(param$1.potionHealAmount);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/potionHealAmount", "potionHealAmount=" + potionHealAmount + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updatePotionHealCooldown(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var potionHealCooldown = String(param$1.potionHealCooldown);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/potionHealCooldown", "potionHealCooldown=" + potionHealCooldown + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updatePreventImpossibleEquipment(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var preventImpossibleEquipment = param$1.preventImpossibleEquipment ? "true" : "false";
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/preventImpossibleEquipment", "preventImpossibleEquipment=" + preventImpossibleEquipment + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateForceMaxHealth(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var forceMaxHealth = param$1.forceMaxHealth ? "true" : "false";
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/forceMaxHealth", "forceMaxHealth=" + forceMaxHealth + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateNeverRain(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var neverRain = param$1.neverRain ? "true" : "false";
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/neverRain", "neverRain=" + neverRain + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateAllowHookOfDissonance(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var allowHookOfDissonance = param$1.allowHookOfDissonance ? "true" : "false";
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/allowHookOfDissonance", "allowHookOfDissonance=" + allowHookOfDissonance + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateCorrectPositionDesync(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var correctPositionDesync = param$1.correctPositionDesync ? "true" : "false";
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/correctPositionDesync", "correctPositionDesync=" + correctPositionDesync + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateCorrectionMinDistance(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var correctionMinDistance = String(param$1.correctionMinDistance);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/correctionMinDistance", "correctionMinDistance=" + correctionMinDistance + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateBeetleArmorStage1(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var weakStage = String(param$1.beetleArmorStages.weakStage);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/beetleArmorStage1", "beetleArmorStage1=" + weakStage + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateBeetleArmorStage2(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var middleStage = String(param$1.beetleArmorStages.middleStage);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/beetleArmorStage2", "beetleArmorStage2=" + middleStage + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateBeetleArmorStage3(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var strongStage = String(param$1.beetleArmorStages.strongStage);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/beetleArmorStage3", "beetleArmorStage3=" + strongStage + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateSolarArmorStage1(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var weakStage = String(param$1.solarArmorStages.weakStage);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/solarArmorStage1", "solarArmorStage1=" + weakStage + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateSolarArmorStage2(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var middleStage = String(param$1.solarArmorStages.middleStage);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/solarArmorStage2", "solarArmorStage2=" + middleStage + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateSolarArmorStage3(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var strongStage = String(param$1.solarArmorStages.strongStage);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/solarArmorStage3", "solarArmorStage3=" + strongStage + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateDefenseMultiplier(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var defenseMultiplier = String(param$1.defenseMultiplier);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/defenseMultiplier", "defenseMultiplier=" + defenseMultiplier + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateDamageVariation(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var damageVariation = String(param$1.damageVariation);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/damageVariation", "damageVariation=" + damageVariation + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function updateTime(param, param$1, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var time = String(param$1.time);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/update/time", "time=" + time + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function addBannedEquipment(param, netId, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var netId$1 = String(netId);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/insert/bannedEquipment", "netId=" + netId$1 + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function removeBannedEquipment(param, netId, cb) {
  var match = param.VAL;
  var sessionId = String(match.id);
  var netId$1 = String(netId);
  return Request$PvpcontrollerWeb.postWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/remove/bannedEquipment", "netId=" + netId$1 + "&sessionId=" + sessionId + "&token=" + match.token, UpdateResponse$PvpcontrollerWeb.Decode.updateResponse, cb);
}

function getChangelog(skip, limit, cb) {
  var skip$1 = String(skip);
  var limit$1 = String(limit);
  return Request$PvpcontrollerWeb.getWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/settings/changelog/" + skip$1 + "/" + limit$1, (function (response) {
                var match = settingsChangelogResponse(response);
                return {
                        TAG: /* Ok */0,
                        _0: {
                          changes: match.changes,
                          totalSize: match.totalSize
                        }
                      };
              }), cb);
}

exports.getSettings = getSettings;
exports.updateDamageDisableSeconds = updateDamageDisableSeconds;
exports.updateBanPrefixedArmor = updateBanPrefixedArmor;
exports.updateBanTeleportItems = updateBanTeleportItems;
exports.updatePotionHealAmount = updatePotionHealAmount;
exports.updatePotionHealCooldown = updatePotionHealCooldown;
exports.updatePreventImpossibleEquipment = updatePreventImpossibleEquipment;
exports.updateForceMaxHealth = updateForceMaxHealth;
exports.updateNeverRain = updateNeverRain;
exports.updateAllowHookOfDissonance = updateAllowHookOfDissonance;
exports.updateCorrectPositionDesync = updateCorrectPositionDesync;
exports.updateCorrectionMinDistance = updateCorrectionMinDistance;
exports.updateBeetleArmorStage1 = updateBeetleArmorStage1;
exports.updateBeetleArmorStage2 = updateBeetleArmorStage2;
exports.updateBeetleArmorStage3 = updateBeetleArmorStage3;
exports.updateSolarArmorStage1 = updateSolarArmorStage1;
exports.updateSolarArmorStage2 = updateSolarArmorStage2;
exports.updateSolarArmorStage3 = updateSolarArmorStage3;
exports.updateDefenseMultiplier = updateDefenseMultiplier;
exports.updateDamageVariation = updateDamageVariation;
exports.updateTime = updateTime;
exports.addBannedEquipment = addBannedEquipment;
exports.removeBannedEquipment = removeBannedEquipment;
exports.getChangelog = getChangelog;
/* Url-PvpcontrollerWeb Not a pure module */
